import React from 'react';

function createComponent(render) {
  var def = typeof render === 'function' ? {render: render} : render;
  render = def.render;

  def.render = function () {
    return render.call(this, this.props.data, this.props.children);
  };

  if (!def.getInitialState) {
    def.getInitialState = function () {
      return {};
    };
  }

  if (def.componentDidMount) {
    var cdm = def.componentDidMount;
    def.componentDidMount = function () {
      cdm.call(this, this.props.data);
    };
  }

  if (def.componentWillReceiveProps) {
    var cwrp = def.componentWillReceiveProps;
    def.componentWillReceiveProps = function (newProps) {
      cwrp.call(this, newProps.data, this.props.data);
    };
  }

  if (def.componentWillUpdate) {
    var cwu = def.componentWillUpdate;
    def.componentWillUpdate = function () {
      cwu.call(this, this.props.data);
    };
  }

  if (def.componentDidUpdate) {
    var cdu = def.componentDidUpdate;
    def.componentDidUpdate = function () {
      cdu.call(this, this.props.data);
    };
  }

  if (def.shouldComponentUpdate) {
    var scu = def.shouldComponentUpdate;
    def.shouldComponentUpdate = function (newp, newState) {
      return scu.call(this, this.props.data, newp.data, this.state, newState);
    };
  } else {
    def.shouldComponentUpdate = function (newp, newState) {
      return this.props.data !== newp.data || this.state !== newState;
    };
  }

  var component = React.createFactory(React.createClass(def));

  var c = function () {
    return component.apply(this, arguments);
  };
  c.displayName = def.displayName;

  return c;
}

export default createComponent;

